export default "__VITE_ASSET__wagU_OWc__"